import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { ModelWithForm } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'

export default function ManageRestaurantToGoKpiSmartview () {
  return (
    <ModelWithForm
      resourceName='economy' operationName='restaurant_to_go_ratio_kpi_read'
      formOperationName='restaurant_to_go_ratio_kpi_store'
    >
      <SelectedDepartmentFilter />
      <Translator namespace='economy.restaurant_to_go.smartview'>
        <Smartview
          size='sm'
          header={(
            <UI.SecondaryHeading>
              <Translation name='title' />
            </UI.SecondaryHeading>
        )}
          footer={(
            <UI.ButtonWrap>
              <UI.SubmitButton>
                <Translation name='generic.save' />
              </UI.SubmitButton>
            </UI.ButtonWrap>
        )}
        >

          <div className='flex flex-col space-y-8'>
            <div className='flex flex-col space-y-2'>
              <UI.Text>
                <Translation name='headers.items_per_guest_restaurant' />
              </UI.Text>
              <Fieldset cols={2}>
                <Fields.Number
                  name='items_per_guest_restaurant_lower_limit'
                  step={0.01}
                  label={<Translation name='generic.lower_limit' />}
                />
                <Fields.Number
                  name='items_per_guest_restaurant_upper_limit'
                  step={0.01}
                  label={<Translation name='generic.upper_limit' />}
                />
              </Fieldset>
            </div>
            <div className='flex flex-col space-y-2'>
              <UI.Text>
                <Translation name='headers.items_per_guest_takeaway' />
              </UI.Text>
              <Fieldset cols={2}>
                <Fields.Number
                  name='items_per_guest_takeaway_lower_limit'
                  step={0.01}
                  label={<Translation name='generic.lower_limit' />}
                />
                <Fields.Number
                  name='items_per_guest_takeaway_upper_limit'
                  step={0.01}
                  label={<Translation name='generic.upper_limit' />}
                />
              </Fieldset>
            </div>
            <div className='flex flex-col space-y-2'>
              <UI.Text>
                <Translation name='headers.beverages_per_guest_restaurant' />
              </UI.Text>
              <Fieldset cols={2}>
                <Fields.Number
                  name='beverages_per_guest_restaurant_lower_limit'
                  step={0.01}
                  label={<Translation name='generic.lower_limit' />}
                />
                <Fields.Number
                  name='beverages_per_guest_restaurant_upper_limit'
                  step={0.01}
                  label={<Translation name='generic.upper_limit' />}
                />
              </Fieldset>
            </div>
            <div className='flex flex-col space-y-2'>
              <UI.Text>
                <Translation name='headers.beverages_per_guest_takeaway' />
              </UI.Text>
              <Fieldset cols={2}>
                <Fields.Number
                  name='beverages_per_guest_takeaway_lower_limit'
                  step={0.01}
                  label={<Translation name='generic.lower_limit' />}
                />
                <Fields.Number
                  name='beverages_per_guest_takeaway_upper_limit'
                  step={0.01}
                  label={<Translation name='generic.upper_limit' />}
                />
              </Fieldset>
            </div>
          </div>

        </Smartview>
      </Translator>

    </ModelWithForm>
  )
}
